import red from '@material-ui/core/colors/red'
import amber from '@material-ui/core/colors/amber'
import green from '@material-ui/core/colors/green'

const colors = {
  red: red[500],
  amber: amber[500],
  green: green[500],
}

export default colors